//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Autocomplete from 'vue2-autocomplete-js';
import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid'; 
import MASTER_MENU from  '../../library/master_menu'
import FETCHING from  '../../library/fetching'




 

export default {
    components: {
        Autocomplete, 
    },          
    data () {
        return {
          // MODAL 
            FETCHING:FETCHING,
            terbitkanSurat  :false,
            modal_edit_anggota_keluarga:false,
            modal_y:false,
            modal_n:false,

            lihat_blue:false,
            lihat_red:false,
          // MODAL 
            option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],

            token : localStorage.token,
            MASTER_MENU:MASTER_MENU,
            UMUM : UMUM,

            shape: '', 
            dense:true, 
            current: 3,
            
            list_anggota_keluarga:[],
            
            list_data:[],
            list_data_kecamatan:[],
            list_data_kabupaten:[],

            page_limit : 10,
            page_first: 1,
            page_last: 0,
            cari_value: "",

            form: {
              id:'',
              KKref:'',
              id_dari_form:'',

              modul:'kk2',

              m_provinsi : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '',


              permohonan: '',
              keterangan_lainnya: '',

              nama: '',
              nik: '',
              nama_kepala_keluarga: '',
              no_kk: '',

              jenis_kelamin:'',
              tempat_lahir:'',
              tanggal_lahir:'',
              status_hubungan_dl_keluarga:'',

                agama:'',
                agama_lainnya:'',
                pekerjaan:'',
                pekerjaan_lainnya:'',
                pendidikan:'',
                pendidikan_lainnya:'',

              alamat: '',
              rt: '',
              rw: '',

              

              provinsi: '',
              kabupaten: '',
              kecamatan: '',
              desa_kelurahan: '',

              kode_pos: '',
              telepon: '',

              nama_kepala_keluarga_lama: '',
              no_kk_lama: '',
              
              alamat_keluarga_lama: '',
              rt_lama: '',
              rw_lama: '',

              provinsi_lama: '',
              kabupaten_lama: '',
              kecamatan_lama: '',
              desa_kelurahan_lama: '',

              kode_pos_lama: '',
              telepon_lama: '',

              // ADMIN 
                status : 0,
                keterangan : 0,
                
                keterangan_deskel:'',
                keterangan_kecamatan:'',
                keterangan_kabupaten  :'',

                status_deskel:0,
                status_kecamatan:0,
                status_kabupaten  :0,

                createdBy : '',
                createdAt : '',
                createdAt_deskel:'',
                createdAt_kecamatan:'',
                createdAt_kabupaten  :'',
              // ADMIN 

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',

              file              : null, 
              fileThumb         : null, 
              file_lampiran     :null,
              file_lampiranOld  : null                            
              
            },
            anggota_keluarga : {
              nik :'',
              nama :'',
              jenis_kelamin :'',
              tempat_lahir :'',
              tanggal_lahir :'',
              status_hubungan_dl_keluarga :'',

            agama:'',
            agama_lainnya:'',
            pekerjaan:'',
            pekerjaan_lainnya:'',
            pendidikan:'',
            pendidikan_lainnya:'',

            KKref:'',
            
            },

            file:'',
            fileOld:'',

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayah_pemohon : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },            
            wilayah_lama : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },            

        }
    },
    methods: {

    // User

      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;  
                this.page_last = res_data.jmlData;   
                // console.log(this.list_data);
        });
      },

      addAnggotaKeluarga:function(){
        var arr = this.list_anggota_keluarga; 
        arr.push(this.anggota_keluarga);
        
        this.anggota_keluarga = {
            nik :'',
            nama :'',
            jenis_kelamin :'',
            tempat_lahir :'',
            tanggal_lahir :'',
            status_hubungan_dl_keluarga :'',

            agama:'',
            agama_lainnya:'',
            pekerjaan:'',
            pekerjaan_lainnya:'',
            pendidikan:'',
            pendidikan_lainnya:'',
            
        }
      },
      EditAnggotaKeluarga:function(){ 
          this.$store.state.modal_loading = true;

          var a = this.form.KKref  
          this.anggota_keluarga.KKref = a 
          console.log('aaaaa = ', a);

          var formData = new FormData(); 
          formData.append("biodata", JSON.stringify(this.anggota_keluarga));

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "editData_AK", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => { 
              this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              var arr = this.list_anggota_keluarga; 
              arr.push(this.anggota_keluarga);
              
              this.anggota_keluarga = {
                  nik :'',
                  nama :'',
                  jenis_kelamin :'',
                  tempat_lahir :'',
                  tanggal_lahir :'',
                  status_hubungan_dl_keluarga :'',

                  agama:'',
                  agama_lainnya:'',
                  pekerjaan:'',
                  pekerjaan_lainnya:'',
                  pendidikan:'',
                  pendidikan_lainnya:'', 

              }

              this.getView();
          }); 
      },
      delete_keluarga : function (index){  
        this.list_anggota_keluarga.splice(index, 1);  
        this.$store.commit('notif_berhasil_menghapus');        
      },
      delete_keluarga2(data, index){  
        this.$store.state.modal_loading = true;

        var idk = data._id  
        console.log(this.index_ke) 
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "hapus_keluarga", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : idk,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.list_anggota_keluarga.splice(index, 1); 
            this.$store.state.modal_loading = false;
            this.$store.commit('notif_berhasil_menghapus'); 
            this.getView();
        });
      },

      validateForm:function(){
        const f = this.form;


        // ========== VALIDASI WILAYAH PERMOHONAN ==========
        if (!f.m_provinsi || f.m_provinsi === ''){
          this.$q.notify({type: 'negative', message: 'Pilih provinsi wilayah administrasi.'});
          return false;
        }
        if (!f.m_kabupaten || f.m_kabupaten === ''){
          this.$q.notify({type: 'negative', message: 'Pilih kabupaten wilayah administrasi.'});
          return false;
        }
        if (!f.m_kecamatan || f.m_kecamatan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih kecamatan wilayah administrasi.'});
          return false;
        }
        if (!f.m_desa_kelurahan || f.m_desa_kelurahan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih desa/kelurahan wilayah administrasi.'});
          return false;
        }


        
        // ========== VALIDASI DATA PEMOHON ==========
        // Permohonan
        if (!f.permohonan || f.permohonan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih alasan permohonan.'});
          return false;
        }
        if (f.permohonan == 'Lainnya' && (!f.keterangan_lainnya || f.keterangan_lainnya.trim() === '')){
          this.$q.notify({type: 'negative', message: 'Isi keterangan permohonan lainnya.'});
          return false;
        }

        // Identitas Pemohon
        if (!f.nama || f.nama.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Nama pemohon wajib diisi.'});
          return false;
        }
        if (!f.nik || f.nik.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'NIK pemohon wajib diisi.'});
          return false;
        }
        if (!f.nama_kepala_keluarga || f.nama_kepala_keluarga.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Nama kepala keluarga wajib diisi.'});
          return false;
        }
        if (!f.no_kk || f.no_kk.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Nomor KK wajib diisi.'});
          return false;
        }

        // Data Biografi
        if (!f.jenis_kelamin || f.jenis_kelamin === ''){
          this.$q.notify({type: 'negative', message: 'Pilih jenis kelamin.'});
          return false;
        }
        if (!f.tempat_lahir || f.tempat_lahir.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Tempat lahir wajib diisi.'});
          return false;
        }
        if (!f.tanggal_lahir || f.tanggal_lahir === ''){
          this.$q.notify({type: 'negative', message: 'Tanggal lahir wajib diisi.'});
          return false;
        }
        if (!f.status_hubungan_dl_keluarga || f.status_hubungan_dl_keluarga === ''){
          this.$q.notify({type: 'negative', message: 'Pilih status hubungan dalam keluarga.'});
          return false;
        }

        // Data Pendidikan, Agama, Pekerjaan
        if (!f.agama || f.agama === ''){
          this.$q.notify({type: 'negative', message: 'Pilih agama.'});
          return false;
        }
        if (f.agama == 'Lainnya' && (!f.agama_lainnya || f.agama_lainnya.trim() === '')){
          this.$q.notify({type: 'negative', message: 'Isi agama/kepercayaan lainnya.'});
          return false;
        }
        if (!f.pekerjaan || f.pekerjaan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih pekerjaan.'});
          return false;
        }
        if (f.pekerjaan == 'Lainnya' && (!f.pekerjaan_lainnya || f.pekerjaan_lainnya.trim() === '')){
          this.$q.notify({type: 'negative', message: 'Isi pekerjaan lainnya.'});
          return false;
        }
        if (!f.pendidikan || f.pendidikan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih pendidikan terakhir.'});
          return false;
        }
        if (f.pendidikan == 'Lainnya' && (!f.pendidikan_lainnya || f.pendidikan_lainnya.trim() === '')){
          this.$q.notify({type: 'negative', message: 'Isi pendidikan lainnya.'});
          return false;
        }



        // ========== VALIDASI ALAMAT PEMOHON ==========
        if (!f.provinsi || f.provinsi === ''){
          this.$q.notify({type: 'negative', message: 'Pilih provinsi alamat.'});
          return false;
        }
        if (!f.kabupaten || f.kabupaten === ''){
          this.$q.notify({type: 'negative', message: 'Pilih kabupaten alamat.'});
          return false;
        }
        if (!f.kecamatan || f.kecamatan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih kecamatan alamat.'});
          return false;
        }
        if (!f.desa_kelurahan || f.desa_kelurahan === ''){
          this.$q.notify({type: 'negative', message: 'Pilih desa/kelurahan alamat.'});
          return false;
        }
        if (!f.alamat || f.alamat.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Alamat wajib diisi.'});
          return false;
        }
        if (f.rt === '' || f.rt === null || f.rt === undefined){
          this.$q.notify({type: 'negative', message: 'RT wajib diisi.'});
          return false;
        }
        if (f.rw === '' || f.rw === null || f.rw === undefined){
          this.$q.notify({type: 'negative', message: 'RW wajib diisi.'});
          return false;
        }
        if (f.kode_pos === '' || f.kode_pos === null || f.kode_pos === undefined){
          this.$q.notify({type: 'negative', message: 'Kode pos wajib diisi.'});
          return false;
        }
        if (!f.telepon || f.telepon.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Telepon wajib diisi.'});
          return false;
        }

        // ========== VALIDASI DATA SEBELUMNYA ==========
        if (!f.nama_kepala_keluarga_lama || f.nama_kepala_keluarga_lama.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Nama kepala keluarga lama wajib diisi.'});
          return false;
        }
        if (!f.no_kk_lama || f.no_kk_lama.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Nomor KK lama wajib diisi.'});
          return false;
        }
        if (!f.alamat_keluarga_lama || f.alamat_keluarga_lama.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Alamat keluarga lama wajib diisi.'});
          return false;
        }
        if (f.rt_lama === '' || f.rt_lama === null || f.rt_lama === undefined){
          this.$q.notify({type: 'negative', message: 'RT lama wajib diisi.'});
          return false;
        }
        if (f.rw_lama === '' || f.rw_lama === null || f.rw_lama === undefined){
          this.$q.notify({type: 'negative', message: 'RW lama wajib diisi.'});
          return false;
        }
        if (!f.provinsi_lama || f.provinsi_lama === ''){
          this.$q.notify({type: 'negative', message: 'Pilih provinsi data sebelumnya.'});
          return false;
        }
        if (!f.kabupaten_lama || f.kabupaten_lama === ''){
          this.$q.notify({type: 'negative', message: 'Pilih kabupaten data sebelumnya.'});
          return false;
        }
        if (!f.kecamatan_lama || f.kecamatan_lama === ''){
          this.$q.notify({type: 'negative', message: 'Pilih kecamatan data sebelumnya.'});
          return false;
        }
        if (!f.desa_kelurahan_lama || f.desa_kelurahan_lama === ''){
          this.$q.notify({type: 'negative', message: 'Pilih desa/kelurahan data sebelumnya.'});
          return false;
        }
        if (f.kode_pos_lama === '' || f.kode_pos_lama === null || f.kode_pos_lama === undefined){
          this.$q.notify({type: 'negative', message: 'Kode pos lama wajib diisi.'});
          return false;
        }
        if (!f.telepon_lama || f.telepon_lama.toString().trim() === ''){
          this.$q.notify({type: 'negative', message: 'Telepon lama wajib diisi.'});
          return false;
        }

        // ========== VALIDASI FILE LAMPIRAN ==========
        if (f.file_lampiran === '' || f.file_lampiran === null || f.file_lampiran === undefined){
          this.$q.notify({type: 'negative', message: 'File lampiran wajib diisi.'});
          return false;
        }

        return true;
      },
      
      addData:function(){
        // Jalankan validasi sebelum submit
        if (!this.validateForm()){
          return;
        }

        this.$store.state.modal_loading = true;
        console.log(this.form);
        var formData = new FormData();

        formData.append("data", JSON.stringify(this.form));
        formData.append("biodata", JSON.stringify(this.list_anggota_keluarga)); 
        formData.append("file",           this.form.file);
        formData.append("file_lampiran",  this.form.file_lampiran);          

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "addData1", {
              method: "POST",
              headers: {
                  // "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => { 
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_berhasil')
              this.getView();
          });
      },
      editData:function(){
        this.$store.state.modal_loading = true;

        console.log('ini form = ', this.form);
        console.log('ini list = ', this.list_anggota_keluarga);

        var formData = new FormData();
        formData.append("data", JSON.stringify(this.form));
        formData.append("biodata", JSON.stringify(this.list_anggota_keluarga));
        formData.append("file",           this.form.file);
        formData.append("file_lampiran",  this.form.file_lampiran);

        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            // console.log(res_data); 
            this.$store.state.modal_loading = false;
            this.$store.commit('notif_edit');
            this.getView();
        });

      },
      removeData(data){ 
        this.$store.state.modal_loading = true;
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                KKref : this.form.KKref,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.$store.state.modal_loading = false;
            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        });         
      },
      clear_data:function(data){
          this.form.id = ''
          this.form.KKre = ''
          this.form.id_dari_form = ''
          this.form.m_provinsi = ''
          this.form.m_kabupaten = ''
          this.form.m_kecamatan = ''
          this.form.m_desa_kelurahan = ''

          this.form.permohonan = ''
          this.form.keterangan_lainnya = ''
          this.form.nama = ''
          this.form.nik = ''
          this.form.nama_kepala_keluarga = ''
          this.form.no_kk = ''
          this.form.agama = ''
          this.form.agama_lainnya = ''
          this.form.pekerjaan = ''
          this.form.pekerjaan_lainnya = ''
          this.form.pendidikan = ''
          this.form.pendidikan_lainnya = ''
          this.form.alamat = ''
          this.form.rt = ''
          this.form.rw = ''
          this.form.provinsi = ''
          this.form.kabupaten = ''
          this.form.kecamatan = ''
          this.form.desa_kelurahan = ''
          this.form.kode_pos = ''
          this.form.telepon = ''
          this.form.nama_kepala_keluarga_lama = ''
          this.form.no_kk_lama = ''
          this.form.alamat_keluarga_lama = ''
          this.form.rt_lama = ''
          this.form.rw_lama = ''
          this.form.provinsi_lama = ''
          this.form.kabupaten_lama = ''
          this.form.kecamatan_lama = ''
          this.form.desa_kelurahan_lama = ''
          this.form.kode_pos_lama = ''
          this.form.telepon_lama = ''
          this.list_anggota_keluarga = []

      },
      selectData(data){
        console.log(data);
              this.form.id = data.KK2.id
              this.form.KKref = data.KK2.KKref
              this.form.id_dari_form = data.KK2.id_dari_form

              this.form.m_provinsi = data.KK2.m_provinsi 
              this.form.m_kabupaten = data.KK2.m_kabupaten 
              this.form.m_kecamatan = data.KK2.m_kecamatan
              this.form.m_desa_kelurahan = data.KK2.m_desa_kelurahan

              this.form.permohonan = data.KK2.permohonan
              this.form.keterangan_lainnya = data.KK2.keterangan_lainnya
              this.form.nama = data.KK2.nama
              this.form.nik = data.KK2.nik
              this.form.nama_kepala_keluarga = data.KK2.nama_kepala_keluarga
              this.form.no_kk = data.KK2.no_kk

              this.form.jenis_kelamin = data.KK2.jenis_kelamin
              this.form.tempat_lahir = data.KK2.tempat_lahir
              this.form.tanggal_lahir = data.KK2.tanggal_lahir
              this.form.status_hubungan_dl_keluarga = data.KK2.status_hubungan_dl_keluarga


              this.form.agama = data.KK2.agama
              this.form.agama_lainnya = data.KK2.agama_lainnya
              this.form.pekerjaan = data.KK2.pekerjaan
              this.form.pekerjaan_lainnya = data.KK2.pekerjaan_lainnya
              this.form.pendidikan = data.KK2.pendidikan
              this.form.pendidikan_lainnya = data.KK2.pendidikan_lainnya
              this.form.alamat = data.KK2.alamat
              this.form.rt = data.KK2.rt
              this.form.rw = data.KK2.rw
              this.form.provinsi = data.KK2.provinsi
              this.form.kabupaten = data.KK2.kabupaten
              this.form.kecamatan = data.KK2.kecamatan 
              this.form.desa_kelurahan = data.KK2.desa_kelurahan
              this.form.kode_pos = data.KK2.kode_pos
              this.form.telepon = data.KK2.telepon
              this.form.nama_kepala_keluarga_lama = data.KK2.nama_kepala_keluarga_lama
              this.form.no_kk_lama = data.KK2.no_kk_lama
              this.form.alamat_keluarga_lama = data.KK2.alamat_keluarga_lama
              this.form.rt_lama = data.KK2.rt_lama
              this.form.rw_lama = data.KK2.rw_lama
              this.form.provinsi_lama = data.KK2.provinsi_lama
              this.form.kabupaten_lama = data.KK2.kabupaten_lama
              this.form.kecamatan_lama = data.KK2.kecamatan_lama
              this.form.desa_kelurahan_lama = data.KK2.desa_kelurahan_lama
              this.form.kode_pos_lama = data.KK2.kode_pos_lama
              this.form.telepon_lama = data.KK2.telepon_lama

              this.form.status = data.KK2.status
              this.form.keterangan = data.KK2.keterangan
              this.form.keterangan_deskel = data.KK2.keterangan_deskel
              this.form.keterangan_kecamatan = data.KK2.keterangan_kecamatan
              this.form.keterangan_kabupaten = data.KK2.keterangan_kabupaten
              this.form.status_deskel = data.KK2.status_deskel
              this.form.status_kecamatan = data.KK2.status_kecamatan
              this.form.status_kabupaten = data.KK2.status_kabupaten
              this.form.createdBy = data.KK2.createdBy
              this.form.createdAt = data.KK2.createdAt
              this.form.createdAt_deskel = data.KK2.createdAt_deskel
              this.form.createdAt_kecamatan = data.KK2.createdAt_kecamatan
              this.form.createdAt_kabupaten = data.KK2.createdAt_kabupaten

              this.list_anggota_keluarga = data.databio

              this.form.emailPemohon          = data.KK2.emailPemohon;
              this.form.email_fileOld         = data.KK2.email_file;
              this.form.email_from            = this.form.email_from;
              this.form.email_to              = this.form.emailPemohon;
              this.form.email_subject         = data.KK2.email_subject;
              if (data.KK2.email_html == undefined || data.KK2.email_html == null || data.KK2.email_html == '') {
                this.form.email_html          = ''
              } else {
                this.form.email_html          = data.KK2.email_html; 
              }

              this.form.file              = data.KK2.file
              this.form.fileThumb         = data.KK2.fileThumb
              this.form.file_lampiran     = data.KK2.file_lampiran
              this.form.file_lampiranOld  = data.KK2.file_lampiranOld

              
              this.wilayah = {
                uraian_provinsi : data.m_provinsi.uraian,
                kd_provinsi : data.m_provinsi.kd_provinsi,
                uraian_kabupaten : data.m_kabupaten.uraian,
                kd_kabupaten : data.m_kabupaten.kd_kabupaten,
                uraian_kecamatan : data.m_kecamatan.uraian,
                kd_kecamatan : data.m_kecamatan.kd_kecamatan,
                uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
                kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
              }
              this.wilayah_pemohon = {
                uraian_provinsi : data.provinsi.uraian,
                kd_provinsi : data.provinsi.kd_provinsi,
                uraian_kabupaten : data.kabupaten.uraian,
                kd_kabupaten : data.kabupaten.kd_kabupaten,
                uraian_kecamatan : data.kecamatan.uraian,
                kd_kecamatan : data.kecamatan.kd_kecamatan,
                uraian_desa_kelurahan : data.desa_kelurahan.uraian,
                kd_desa_kelurahan : data.desa_kelurahan.kd_desa_kelurahan,
              }
              this.wilayah_lama = {
                uraian_provinsi : data.provinsi_lama.uraian,
                kd_provinsi : data.provinsi_lama.kd_provinsi,
                uraian_kabupaten : data.kabupaten_lama.uraian,
                kd_kabupaten : data.kabupaten_lama.kd_kabupaten,
                uraian_kecamatan : data.kecamatan_lama.uraian,
                kd_kecamatan : data.kecamatan_lama.kd_kecamatan,
                uraian_desa_kelurahan : data.desa_kelurahan_lama.uraian,
                kd_desa_kelurahan : data.desa_kelurahan_lama.kd_desa_kelurahan,
              }

      },    
    // User
      // ============================= KECAMATAN =============================
        getViewKecamatan : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "viewKecamatan", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kecamatan : this.form.status_kecamatan,
                  pl_provinsi       :this.$store.state.lcProfile.provinsi,
                  pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                  pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
              })
            })
              .then(res => res.json())
              .then(res_data => { 
                  this.list_data_kecamatan = res_data.data;
                  this.page_last = res_data.jmlData; 
                  // console.log("INI KECAMATAN")
                  console.log(res_data);
          });
        },


        editDataKecamatan : function(status){
          // console.log(status)
          this.$store.state.modal_loading = true;

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "editDataKecamatan", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kecamatan : this.form.keterangan_kecamatan,
                createdAt_kecamatan : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getViewKecamatan();
          });
        },

      // ============================= KECAMATAN =============================

      // ============================= KABUPATEN =============================
        getViewKabupaten : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "viewKabupaten", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kabupaten : this.form.status_kabupaten
              })
            })
              .then(res => res.json())
              .then(res_data => {
                // console.log("TAAAAAAAAAAIIIIIIII")
                  this.list_data_kabupaten = res_data.data;
                  this.page_last = res_data.jmlData;
                  // this.$store.commit("hideLoading");
                  console.log(res_data);
          });
        }, 
        editDataKabupaten : function(status){
          console.log("SA DI CLICK")
          this.$store.state.modal_loading = true;
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "editDataKabupaten", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kabupaten : this.form.keterangan_kabupaten,
                createdAt_kabupaten : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getViewKabupaten();
          });
        }, 
        terbit_file_Kabupaten : function(){
          this.$store.state.modal_loading = true;
          console.log(this.form.email_fileOld);
          var formData = new FormData();
          formData.append("id", this.form.id);
          formData.append("email_file", this.form.email_file); 
          formData.append("email_fileOld", this.form.email_fileOld); 
          formData.append("email_from", this.form.email_from)
          formData.append("email_to", this.form.email_to)
          formData.append("email_subject", this.form.email_subject) 
          formData.append("email_html", this.form.email_html)
          
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "file_terbitan_Kabupaten", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData,
          }).then(res_data => { 
              this.wa_notif()
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_terbit');
              this.getView();
          });
        },
        async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Permohonan Perubahan Kartu Keluarga (KK) Baru Warga Negara Indonesia'
          }))
          console.log(data);
        },
      // ============================= KABUPATEN =============================
    
      bukaTab(linknya){
        window.open(linknya);
      },

    // ====================================== filter autocomplete  
      renderChildProv(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKab(data) {
          return `
          <span><b>${data.kd_kabupaten}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKec(data) {
          return `
          <span><b>${data.kd_kecamatan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChild_des_kel(data) {
          return `
          <span><b>${data.kd_desa_kelurahan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    

      get_auto(data){
        this.form.m_provinsi = data.m_provinsi   
        // console.log(data.kd_provinsi); 
      },        
      get_auto_kab(data){ 
        this.form.m_kabupaten = data.m_kabupaten  
        // console.log(data.kd_kabupaten); 
      },        
      get_auto_kec(data){ 
        this.form.m_kecamatan = data.m_kecamatan  
        // console.log(data.kd_kecamatan); 
      },        
      get_auto_des_kel(data){ 
        this.form.m_desa_kelurahan = data.m_desa_kelurahan  
        // console.log(data.kd_desa_kelurahan); 
      },  

      // ==== daerah ================ 
        get_prov(data){ 
          this.form.provinsi = data.m_provinsi   
        },        
        get_kab(data){ 
          this.form.kabupaten = data.m_kabupaten   
        },        
        get_kec(data){ 
          this.form.kecamatan = data.m_kecamatan   
        },        
        get_des_kel(data){ 
          this.form.desa_kelurahan = data.m_desa_kelurahan   
        },        
      // ==== daerah ================  

      // ==== daerah _ lama ================ 
        get_prov_lama(data){ 
          this.form.provinsi_lama = data.m_provinsi   
        },        
        get_kab_lama(data){ 
          this.form.kabupaten_lama = data.m_kabupaten   
        },        
        get_kec_lama(data){ 
          this.form.kecamatan_lama = data.m_kecamatan   
        },        
        get_des_kel_lama(data){ 
          this.form.desa_kelurahan_lama = data.m_desa_kelurahan   
        },        
      // ==== daerah  _ lama ================  
    // ====================================== filter autocomplete

    // ====================================== LEVEL USER 
      CariData(){
        
        // console.log(this.$store.state.lcProfile.kelas)

        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },

      cekButton_status_kecamatan: function(data){  
        var a = data.KK2.status 
        var status_kab = data.KK2.status_kabupaten  
        if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
          if (status_kab == 1) {
            return true
          }
          return false
        }else{
          if (a == 1) {
            return true
          }else{
            return false
          }
        }  
      },
    // ====================================== LEVEL USER

 
 
 
    },
    mounted() {
      this.list_anggota_keluarga = [];
      // this.getView();
      this.CariData();
      this.MASTER_MENU.agama();
      this.MASTER_MENU.pekerjaan();
      this.MASTER_MENU.pendidikan();
      this.MASTER_MENU.shdk();

      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from 
    },
}
